import { CSSProperties } from 'react';

import UIConfig from '@/UIConfig.ts';

export const containerStyle: CSSProperties = {
  width: '100%',
  height: 'calc(100% - 110px)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  color: 'black',
  backgroundColor: UIConfig.Colors.BackgroundWhite,
  borderTopLeftRadius: UIConfig.Card.Content.borderRadius,
  borderTopRightRadius: UIConfig.Card.Content.borderRadius,
  position: 'relative',
  zIndex: 2,
  marginTop: '-40px'
};

export const headerStyle: CSSProperties = {
  textAlign: 'left',
  marginLeft: '25px',
  marginBottom: '15px'
};

export const skeletonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh', // На весь экран
  width: '100%'
};
